import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function DoacaoScreen() {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const pixKey = 'meucurriculopopular@gmail.com';

  const handleCopyPix = () => {
    navigator.clipboard.writeText(pixKey);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div style={{ maxWidth: 700, margin: '0 auto', paddingTop: 32, paddingBottom: 48 }}>
      <div style={{ textAlign: 'center', marginBottom: 32 }}>
        <img 
          src="/assets/icone-doacao.png" 
          alt="Ícone Doação" 
          style={{ width: 100, height: 100, marginBottom: 16 }} 
        />
        <h1 style={{ 
          color: 'var(--primary-color)', 
          fontWeight: 700, 
          fontSize: 28, 
          marginBottom: 8 
        }}>
          Apoie o Currículo Popular
        </h1>
      </div>

      <div style={{ 
        backgroundColor: '#f8f9fa', 
        borderRadius: 12, 
        padding: 32, 
        lineHeight: 1.8,
        fontSize: 16,
        color: 'var(--text-color)'
      }}>
        <p style={{ marginBottom: 20 }}>
          O <strong>Currículo Popular</strong> é um projeto 100% voluntário que ajuda 
          milhares de pessoas a conseguirem emprego através de currículos profissionais 
          e gratuitos.
        </p>

        <p style={{ marginBottom: 20 }}>
          Para manter nosso site no ar, precisamos cobrir custos de <strong>infraestrutura</strong>, 
          como servidores e domínio, além de investir no <strong>desenvolvimento</strong> de 
          novas funcionalidades que beneficiam ainda mais pessoas.
        </p>

        <p style={{ marginBottom: 20 }}>
          Se você acredita na nossa causa e deseja contribuir para que mais pessoas 
          tenham acesso a oportunidades de emprego, considere fazer uma doação. 
          <strong> Qualquer valor faz diferença!</strong>
        </p>

        <div style={{ 
          backgroundColor: 'white', 
          borderRadius: 8, 
          padding: 24, 
          marginTop: 24,
          border: '2px solid var(--primary-color)',
          textAlign: 'center'
        }}>
          <p style={{ 
            fontWeight: 600, 
            marginBottom: 12, 
            color: 'var(--primary-color)',
            fontSize: 18 
          }}>
            Chave PIX
          </p>
          <p style={{ 
            fontSize: 16, 
            fontFamily: 'monospace',
            backgroundColor: '#f0f4f8',
            padding: '12px 16px',
            borderRadius: 6,
            marginBottom: 16,
            wordBreak: 'break-all'
          }}>
            {pixKey}
          </p>
          <button
            onClick={handleCopyPix}
            style={{
              backgroundColor: copied ? '#28a745' : 'var(--primary-color)',
              color: 'white',
              border: 'none',
              padding: '10px 24px',
              borderRadius: 6,
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: 600,
              transition: 'background-color 0.2s'
            }}
          >
            {copied ? '✓ Copiado!' : 'Copiar Chave PIX'}
          </button>
        </div>

        <p style={{ marginTop: 24, marginBottom: 0, textAlign: 'center', fontStyle: 'italic', color: '#666' }}>
          Agradecemos de coração por ajudar a transformar vidas! 💙
        </p>
      </div>

      <div style={{ textAlign: 'center', marginTop: 32 }}>
        <button
          className="btn btn-primary"
          onClick={() => navigate('/')}
          style={{ fontSize: 16, padding: '12px 32px' }}
        >
          Voltar ao Início
        </button>
      </div>
    </div>
  );
}
